import React from "react";
import ReactDOM from "react-dom/client";
import "./style.scss";
import App from "./App";
import Impressum from "./pages/Impressum";
import AccountDeletion from "./pages/AccountDeletion";
import Main from "./pages/Main";
import Users from "./pages/Users";
import Statistics from "./pages/Statistics";
import Plans from "./pages/Plans";
import Editplan from "./pages/Editplan";
import Createplan from "./pages/CreatePlan";
import Workouts from "./pages/Workouts";
import Sessions from "./pages/Sessions";
import Settings from "./pages/Settings";
import CreateWorkout from "./pages/CreateWorkout";
import EditWorkout from "./pages/EditWorkout";
import EditSession from "./pages/EditSession";
import CreateSession from "./pages/CreateSession";
import EditUser from "./pages/EditUser";

import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
//https://github.com/remix-run/react-router/blob/main/docs/start/tutorial.md

const app = (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/impressum" element={<Impressum />} />
      <Route path="/konto-loeschen" element={<AccountDeletion />} />
      <Route path="/home/dashboard" element={<Main />} />
      <Route path="/home/users" element={<Users />} />
      <Route path="/home/statistics" element={<Statistics />} />
      <Route path="/home/plans" element={<Plans />} />
      <Route path="/home/editplan" element={<Editplan />} />
      <Route path="/home/createplan" element={<Createplan />} />
      <Route path="/home/workouts" element={<Workouts />} />
      <Route path="/home/sessions" element={<Sessions />} />
      <Route path="/home/settings" element={<Settings />} />
      <Route path="/home/createworkout" element={<CreateWorkout />} />
      <Route path="/home/editworkout" element={<EditWorkout />} />
      <Route path="/home/editsession" element={<EditSession />} />
      <Route path="/home/createsession" element={<CreateSession />} />
      <Route path="/home/edituser" element={<EditUser />} />
    </Routes>
  </BrowserRouter>
);

const rootElement = document.getElementById("root");

if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
